module.exports = __webpack_public_path__ + "static/mm-ac5350801e44123f253f4e9ceb0b87d8.jpg";